import { createSlice } from '@reduxjs/toolkit';

// Define an initial state with boolean flags for component zoom states
const initialState = {
  isMapZoomed: false,
  isPropertyInfoZoomed: false
};

const zoomSlice = createSlice({
  name: 'zoom',
  initialState,
  reducers: {
    toggleMapZoom(state) {
      state.isMapZoomed = !state.isMapZoomed;
      state.isPropertyInfoZoomed = false;
    },
    togglePropertyInfoZoom(state) {
      state.isPropertyInfoZoomed = !state.isPropertyInfoZoomed;
      state.isMapZoomed = false;
    },
    resetZoom(state) {
      state.isMapZoomed = false;
      state.isPropertyInfoZoomed = false;
    }
  }
});

export const {
  toggleMapZoom,
  togglePropertyInfoZoom,
  resetZoom
} = zoomSlice.actions;

export default zoomSlice.reducer;
